import dayjs, { Dayjs } from 'dayjs';
import { DriverLocation, Product } from '../models';
import { PurchaseItem, PurchaseStatus } from '../models/payment.models';

export const isPdrOrder = (order: { purchaseItems?: PurchaseItem[] }) => {
  return (
    order.purchaseItems &&
    order.purchaseItems?.filter(
      (pi) =>
        pi.product === Product.Pdr && pi.status === PurchaseStatus.Finalized
    ).length > 0
  );
};

export const isAppointmentOrder = (order: {
  purchaseItems?: PurchaseItem[];
}) => {
  return Boolean(
    order.purchaseItems &&
      order.purchaseItems.filter(
        (pi) =>
          pi.product === Product.Appointment &&
          pi.status === PurchaseStatus.Finalized
      ).length > 0
  );
};

function isBeforeMaxTime(eta: dayjs.Dayjs, difference?: number): boolean {
  return eta?.subtract(difference || 0, 'hours').diff(dayjs()) > 0;
}

export function getIsInTime(
  order: { driverLocation?: DriverLocation },
  beforeEta: number
) {
  let eta: Dayjs | null = null;
  if (order.driverLocation?.eta) {
    eta = dayjs(order.driverLocation?.eta);
  }

  let isRightTime: boolean = true;
  if (eta) {
    isRightTime = isBeforeMaxTime(eta, beforeEta);
  }
  return isRightTime;
}
